var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("Sorry, you have no access to this page. | 403")]),_c('div',[_vm._v("Извините, у вас нет доступа к данной странице. | 403")]),_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go back")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }